import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import QuestionnairePageContainer from './QuestionnairePageContainer';
import TaskContainer from './TaskContainer';

class RightPanelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      component: null,
      taskId: 0,
      type: 1,
    };
  }

  // constructor(props) {
  //   super(props);
  // }

  // componentDidMount() {
  //   addToHistory(window.location.pathname);
  // }

  // componentWillUnmount() {
  //  }

  // componentDidUpdate() {

  // }

  isMenusLoaded = () => (this.props && this.props.caseDatacollectMenu ? this.props.caseDatacollectMenu.menusLoaded : []);

  getMenus = () =>
    this.props && this.props.caseDatacollectMenu && this.props.caseDatacollectMenu.menuDetails
      ? this.props.caseDatacollectMenu.menuDetails
      : [];

  render() {
    let menutypecode = null;
    if (this.isMenusLoaded() && this.getMenus().length === 0) {
      return intl.get('newDashboard.common.noItemtoDisplay');
    }

    if (this.getMenus().length > 0 && this.props.location && this.props.location.pathname) {
      let menuCode = this.props.caseDatacollectMenu.menuDetails
        .filter(menudetail => menudetail.pageId === this.props.location.pathname.split('/')[3])
        .map(menudetail => menudetail.menuTypeCode);
      menutypecode = menuCode[0];
    }

    return (
      <React.Fragment>
        {/* <RightPanelPres {...this.props} {...this.state} /> */}
        {menutypecode === 1 ? <QuestionnairePageContainer {...this.props} {...this.state} /> : null}
        {(menutypecode === 2 || menutypecode === 3) && <TaskContainer {...this.props} {...this.state} />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state.login.userInfo,
    caseDatacollectMenu: state.caseDatacollectMenu,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RightPanelContainer);
